import axios from "axios";
import store from "@/store";
import router from "@/router";
import {toast} from "../class/Notification";
import {findObjectIndex} from "../class/Converter";
import {queryBuilder, filters} from '../class/QueryFilter'

let filtersCopy = JSON.parse(JSON.stringify(filters))

const contentDataShape = (form) => {
    let formData = new FormData();
    for (let i in form.keyWords) {
        formData.append(`keywords[${i}]`, form.keyWords[i]);
    }

    for (let i in form.selectedCategory) {
        formData.append(`category_id[${i}]`, form.selectedCategory[i].id);
    }

    formData.append("title", form.title);
    formData.append("content_type", form.content_type);
    formData.append("free", form.free ? 1 : 0);
    formData.append("slug", form.slug);
    formData.append("abstraction", form.abstraction);
    formData.append("body", form.body);
    formData.append("section_name", form.section_name);
    formData.append("course_id", form.course_id);
    formData.append("old_course_id", form.old_course_id);
    formData.append("language_id", form.language_id);

    formData.append("status", form.status ? 1 : 0);
    return formData;
};


export default {
    namespaced: true,
    state: {
        contents: [],
        post: {},
        content: {},
        meta: {},
        trash: [],
        lesson: {},
        lessonIsAccessed: false,
        ...filtersCopy
    },
    mutations: {
        setContents(state, response) {
            state.contents = response;
        },
        setPost(state, response) {
            state.post = response;
        },
        setContent(state, response) {
            state.content = response;
        },
        setMeta(state, meta) {
            state.meta = meta;
        },
        deleteContent: (state, response) => {
            state.contents.splice(
                findObjectIndex(store.getters["Content/getContents"], response),
                1
            );
            state.trash.splice(
                findObjectIndex(store.getters["Content/getTrashContents"], response),
                1
            );
        },
        setTrash(state, response) {
            state.trash = response;
        },
        setLesson(state, lesson) {
            state.lesson = lesson
        },
        setUserAccessToLesson(state, access) {
            state.lessonIsAccessed = access
        },
        setFilters(state, filter) {
            const keys = Object.keys(state.filters)
            for (let i in keys) {
                state.filters[filter.key] = filter.value;
                return
            }
        },
    },
    actions: {
        getContents({commit, state}, form) {
            const query = queryBuilder(state.filters)
            axios
                .get(`/content?content_type=${form.type}&page=${form.page}&${query}`)
                .then((res) => {
                    let response = res.data.data;
                    commit("setContents", response.data);
                    commit("setMeta", response.meta);
                })
                .catch((error) => {
                    console.log(error);
                })
        },
        getDashboardContents({commit, state}, form) {
            const query = queryBuilder(state.filters)
            axios
                .get(`dashboard/content?content_type=${form.type}&${query}&page=${form.page}`)
                .then((res) => {
                    let response = res.data.data;
                    commit("setContents", response.data);
                    commit("setMeta", response.meta);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        showSingleContent({commit}, slug) {
            axios
                .get(`/content/${slug}`)
                .then((res) => {
                    let response = res.data.data;
                    commit("setContent", response);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        createContent({commit}, form) {
            const user_id = store.getters["User/getUserId"];
            let formatData = contentDataShape(form);
            formatData.append("thumbnail", form.mainImage);
            formatData.append("author", user_id);

            axios
                .post("/content", formatData)
                .then((res) => {
                    let response = res.data.data;
                    commit("setContent", response);
                    if (response.content_type == 2) {
                        router.push({
                            name: "UpdateLessons",
                            params: {slug: response.slug},
                        });
                    } else {
                        router.push({
                            name: "UpdateContent",
                            params: {slug: response.slug},
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        updateContent({commit}, form) {
            const user_id = store.getters["User/getUserId"];
            const image = form.mainImage;
            const id = form.id;
            let formatData = contentDataShape(form);
            if (form.mainImage !== undefined) {
                if (form.mainImage.length !== 0) {
                    formatData.append("thumbnail", image);
                    formatData.append("_method", "PUT");
                } else {
                    formatData.append("_method", "PUT");
                }
            }
            formatData.append("author", user_id);
            axios
                .post(`/content/${id}`, formatData)
                .then((res) => {
                    let response = res.data.data;
                    commit("setContent", response);
                    toast("عملیات با موفقیت انجام شد", "ویرایش  با موفقیت انجام شد.");
                    if (response.content_type == 2) {
                        router.push({
                            name: "UpdateLessons",
                            params: {slug: response.slug},
                        });
                    } else {
                        router.push({
                            name: "UpdateContent",
                            params: {slug: response.slug},
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getContent({commit}, slug) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/content/${slug}`)
                    .then((res) => {
                        let response = res.data.data;
                        commit("setContent", response);
                        resolve(response);
                    })
                    .catch((error) => {
                        router.push({name: 'NotFound'})
                        reject(error);
                    });
            });
        },
        getDashboardContent({commit}, slug) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`dashboard/single/content/${slug}`)
                    .then((res) => {
                        let response = res.data.data;
                        commit("setContent", response);
                        resolve(response);
                    })
                    .catch((error) => {
                        console.log(error);
                        reject(error);
                    });
            });
        },
        getTrashContents({commit}, {content_type, page = 1}) {
            axios
                .post(`/content/trash?content_type=${content_type}&page=${page}`)
                .then((res) => {
                    let response = res.data.data;
                    commit("setTrash", response.data);
                    commit("setMeta", response.meta);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        deleteContent({commit}, item) {
            axios
                .delete(`/content/${item.id}`)
                .then((res) => {
                    let response = res.data.data;
                    commit("deleteContent", item);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        restoreContent({commit}, itemId) {
            axios
                .put(`/content/${itemId}/restore`)
                .then((res) => {
                    let response = res.data.data;
                    commit("deleteContent", response);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        forceDeleteContent({commit}, item) {
            axios
                .delete(`/content/${item.id}/force-delete`)
                .then((res) => {
                    let response = res.data.data;
                    commit("deleteContent", item);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getLesson({commit}, form) {
            axios.get(`course/${form.courseSlug}/lesson/${form.lessonSlug}`)
                .then((res) => {

                    commit("setLesson", res.data.data);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getUserAccessToCourse({commit}, form) {
            axios.get(`course/${form.courseSlug}/user/check-access`)
                .then((res) => {

                    commit("setUserAccessToLesson", res.data.data);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getContentsWithoutState({commit, state}, {form}) {
            /* used on wrapper */
            const query = queryBuilder(state.filters)
            return axios.get(`/content?content_type=${form.type}&page=${form.page}&${query}`)
        },
        getContentWithoutState({commit}, slug) {
            return axios.get(`/content/${slug}`)
        },
        getLessonWithoutState({commit}, form) {
            return axios.get(`course/${form.courseSlug}/lesson/${form.lessonSlug}`)
        },
        getUserAccessToCourseWithoutState({commit}, form) {
            return axios.get(`course/${form.courseSlug}/user/check-access`)
        },
        checkReadLessonWithoutState({commit}, form) {
            return axios.get(`/course/${form.lessonLink}/user/check-lesson-read-status`)
        },
        readerOfLessonWithoutState({commit}, form) {
            return axios.get(`/course/${form.lessonLink}/users-read-lesson?page=${form.page}`)
        },
        setReadLessonWithoutState({commit}, form) {
            return axios.get(`/course/${form.lessonLink}/user/set-lesson-read-status`)
        },
        changeStatus({commit}, form) {
            // todo move to separate module
            return axios.post(`change/status`, form)
        },
        duplicateItem({commit}, form) {
            // todo move to separate module
            return axios.post(`duplicate-item`, form)
        },
        async getDashboardLesson({commit}, slug) {
            return await axios.get(`course/lesson/${slug}`)
        },
        async checkCourseContentConditionsWithoutState({commit}, form) {
            return await axios.get(`/check-course-conditions/course/${form.courseSlug}/lesson/${form.lessonSlug}`)
        }
    },
    getters: {
        getContents: (state) => state.contents,
        getPost: (state) => state.post,
        getContent: (state) => state.content,
        getPaginationMeta: (state) => state.meta,
        getTrashContents: (state) => state.trash,
        getLesson: (state) => state.lesson,
        getUserAccessToCourse: (state) => state.lessonIsAccessed,
        getFilters: (state) => state.filters,
    },
};
